import React, { Component } from 'react';
import Header from './Header';
import Footer from './Footer';
import {NavLink, Link} from 'react-router-dom';
import Transcripts from './AcademicsMgt/Transcripts';
import ResultSlip from './AcademicsMgt/ResultSlip';
import UnitRegistration from './AcademicsMgt/UnitRegistration';
import { HashRouter, Route, Switch} from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom'
import LectureEvaluation from './AcademicsMgt/LectureEvaluation';


class Academics extends Component {

    constructor(props) {
        super(props);


         this.state={
          user_details:this.props.user_details,
          access_token:this.props.access_token,
         }
    }


  render() {
    const _this=this;

    return (
      <div className="main-panel">

        <Header title = "Academics" />


        <div className="content-inner">
            <div className="container-fluid">
                <div className="row">
                    <ul className="nav nav-pills nav-pills-warning" role="tablist">
                            <li className="nav-item">
                            <Link className="nav-link" to="/student_ui/academics/unitregistration" role="tablist">
                                UNIT REGISTRATION
                            </Link>
                            </li>
                            <li className="nav-item">
                            <Link className="nav-link "  to="/student_ui/academics/resultslip" role="tablist">
                                PROGRESS REPORT
                            </Link>
                            </li>

                            <li className="nav-item">
                            <Link className="nav-link "  to="/student_ui/academics/lecturer-evaluation" role="tablist">
                                LECTURER EVALUATION
                            </Link>
                            </li>



                    </ul>
                </div>

                <div className ="row full-width">
                    <Switch>
                        < Route
                                exact path="/student_ui/academics"
                                render={(props) => <UnitRegistration {...props} student_details = {_this.props.student_details}
                                                                          base_url={_this.props.base_url}
                                                                          loginStatus= {this.props.loginStatus}
                                                                          updateStudentDetails={_this.props.updateStudentDetails}/> }
                        />
                        <Route
                                exact path="/student_ui/academics/unitregistration"
                                render={(props) => <UnitRegistration {...props} student_details = {_this.props.student_details}
                                                                          base_url={_this.props.base_url}
                                                                          loginStatus= {this.props.loginStatus}
                                                                          updateStudentDetails={_this.props.updateStudentDetails}/> }
                        />

                        <Route
                                exact path="/student_ui/academics/resultslip"
                                render={(props) => <ResultSlip {...props} student_details = {_this.props.student_details}
                                                                          base_url={_this.props.base_url}
                                                                          loginStatus= {this.props.loginStatus}
                                                                          updateStudentDetails={_this.props.updateStudentDetails}/> }
                        />

                         <Route
                                exact path="/student_ui/academics/lecturer-evaluation"
                                render={(props) => <LectureEvaluation {...props} student_details = {_this.props.student_details}
                                                                          base_url={_this.props.base_url}
                                                                          loginStatus= {this.props.loginStatus}
                                                                          updateStudentDetails={_this.props.updateStudentDetails}/> }
                        />

                    </Switch>
                </div>

            </div>
        </div>

        <Footer/>

      </div>
    );
  }
}

export default Academics;
